import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { SuiButton, SuiTextInput } from '@splashthat/sui';
import Search from 'common/icons/Search';

import { SearchInputContainer } from './SearchBar.styles';

export default function SearchBar({ setSearchValue, searchValue, placeholder, qaId }) {
    const searchInputRef = useRef(null);
    const onSearchClearButtonClick = () => {
        setSearchValue('');
        searchInputRef.current.focus();
    };

    const onSearchInputChange = (event) => {
        const { value } = event.target;
        setSearchValue(value);
    };

    return (
        <SearchInputContainer variation="padded-lean full-width" className={`${qaId}_search-input-container`}>
            <SuiTextInput
                ref={searchInputRef}
                focusOnMount
                value={searchValue}
                className={`${qaId}_search-input`}
                placeholder={placeholder}
                onChange={onSearchInputChange}
                fullWidth
                iconRight={
                    searchValue ? (
                        <SuiButton label="Clear" variation="text" onClick={onSearchClearButtonClick} />
                    ) : (
                        Search
                    )
                }
            />
        </SearchInputContainer>
    );
}

SearchBar.propTypes = {
    setSearchValue: PropTypes.func.isRequired,
    searchValue: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    qaId: PropTypes.string,
};

SearchBar.defaultProps = {
    qaId: 'SearchBar',
};
